module.exports = __webpack_public_path__ + "static/media/drag.d233b608.svg";